import { Table } from 'react-dsgov';
import { BrButton, BrLoading } from '@govbr-ds/react-components';
import { useNavigate } from 'react-router-dom';
import styles from './naoIniciadaTable.module.scss';
import { IDeclaracaoTitularArrendatarioNaoIniciada } from '../../../../../interfaces/IDeclaracoes';
import { exercicioMesAnoParaMes } from '../../../../../utils/abreviacaoParaMes';
import { formatarExercicio } from '../../../../../utils/formatExercicio';

interface IHeader {
  field: string;
  label: string;
}

interface IProps {
  isLoading: boolean;
  page: 'titular-ou-arrendatario';
  data: IDeclaracaoTitularArrendatarioNaoIniciada[];
}

export const NaoIniciadaTable = ({ isLoading, page, data }: IProps) => {
  const navigate = useNavigate();

  const statusColumn = (status: string) => {
    if (status === 'DENTRO_DO_PRAZO')
      return (
        <>
          <i className={`fas fa-info-circle fa-md ${styles.blueIcon}`} /> Dentro do prazo
        </>
      );
    if (status === 'FORA_DO_PRAZO')
      return (
        <>
          <i className={`fas fa-times-circle fa-md ${styles.redIcon}`} /> Fora do Prazo
        </>
      );
  };

  const onIniciarClick = (mes: string) => {
    navigate(`/${page}/edit?id=${crypto.randomUUID()}`);
    sessionStorage.setItem('mesDeclaracao', mes);
  };

  let headers: IHeader[] = [];

  headers = [
    { field: 'statusExercicio', label: 'Status' },
    { field: 'exercicio', label: 'Exercício' },
    { field: 'acao-iniciar', label: 'Ação' },
  ];

  return (
    <div className={`${styles.customTable} `}>
      <Table showTopBar={false} headers={headers} showPagination={false}>
        <tbody>
          {!isLoading && data.length === 0 && (
            <tr>
              <td colSpan={3} className={styles.noData}>
                Não há declarações não iniciadas.
              </td>
            </tr>
          )}
          {!isLoading &&
            data.map((declaracao, index) => (
              <tr key={index}>
                <td className={styles.statusColumn}>{statusColumn(declaracao.status)}</td>
                <td className={styles.statusColumn}>{formatarExercicio(declaracao.exercicio)}</td>
                <td className={styles.actionColumn}>
                  <BrButton onClick={() => onIniciarClick(exercicioMesAnoParaMes(declaracao.exercicio).toString())}>
                    <i className={`fas fa-edit fa-md ${styles.columnIcon}`} /> Iniciar
                  </BrButton>
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
      {isLoading && (
        <div className={styles.tableLoading}>
          <BrLoading large label='Carregando...' />
        </div>
      )}
    </div>
  );
};
